import styled from "styled-components";
import { colors, font, radius } from "../../styles/theme/tokens";

const MOBILE = "@media (max-width: 768px)";

export const Backdrop = styled.div`
  position: fixed;
  inset: 0;
  z-index: 99;
  background: rgba(30, 27, 58, 0.45);
  backdrop-filter: blur(2px);
  opacity: ${(props) => (props.$open ? 1 : 0)};
  pointer-events: ${(props) => (props.$open ? "auto" : "none")};
  transition: opacity 0.25s ease;
`;

export const Panel = styled.aside`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  width: 264px;
  height: 100%;
  overflow-y: auto;
  padding-bottom: 16px;
  background: ${colors.surface};
  border-right: 1px solid ${colors.line};

  @media (min-width: 1280px) {
    width: 284px;
  }

  ${MOBILE} {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    z-index: 100;
    width: min(84vw, 320px);
    border-right: none;
    box-shadow: 0 0 40px rgba(30, 27, 58, 0.25);
    transform: translateX(${(props) => (props.$open ? "0" : "-105%")});
    transition: transform 0.28s cubic-bezier(0.22, 1, 0.36, 1);
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 22px 10px;

  .left-panel-logo svg {
    display: block;
    width: auto;
    height: 46px;
  }
`;

export const CloseButton = styled.button`
  display: grid;
  place-items: center;
  width: 38px;
  height: 38px;
  border-radius: ${radius.pill};
  color: ${colors.muted};
  background: ${colors.bg};
  cursor: pointer;
`;

export const Profile = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 0 14px 18px;
  padding: 12px;
  border-radius: ${radius.lg};
  background: ${colors.bg};
`;

export const Avatar = styled.img`
  width: 48px;
  height: 48px;
  flex-shrink: 0;
  object-fit: contain;
  border-radius: ${radius.pill};
  background: ${colors.surface};
  padding: 4px;
`;

export const ProfileText = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
`;

export const Hello = styled.span`
  font-family: ${font.text};
  font-size: 12px;
  font-weight: 600;
  color: ${colors.muted};
`;

export const Name = styled.span`
  font-family: ${font.text};
  font-size: 16px;
  font-weight: 800;
  color: ${colors.ink};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Role = styled.span`
  font-family: ${font.text};
  font-size: 12px;
  font-weight: 600;
  color: ${colors.brandDeep};
`;

export const RoleBadge = styled.span`
  align-self: flex-start;
  margin: 0 24px 18px;
  padding: 5px 12px;
  border-radius: ${radius.pill};
  font-family: ${font.text};
  font-size: 13px;
  font-weight: 700;
  color: ${colors.brandDeep};
  background: ${colors.brandSoft};
`;

export const Footer = styled.div`
  margin-top: auto;
  padding: 18px 14px 0;
`;
